/*!
 *
 *  accept-tel.js
 *
 */

module.exports = function(options){
	var defo = {
		enableClass: 'tel-enable',
		disableClass: 'tel-disable'
	};
	var setting = $.extend({}, defo, options);
	var $tel = $('a[href^="tel:"]');

	if( origin.ua.isMobile ){
		$tel.addClass(setting.enableClass);
	}else{
		$tel.addClass(setting.disableClass).on('tap', function(e) {
			e.preventDefault();
		});
	};
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/accept-tel.js
// module id = 14
// module chunks = 0